import React, { useContext } from "react";
import { useState } from "react";
import "./HomePrimaryComp.css";
import { useEffect } from "react";

import bg1 from "../../../assets/images/bodyfirst.png";
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import icon from "../../../assets/images/arrowblackright.png";
import iconTelegram from "../../../assets/images/65abf617f87cb7ae041482b4_telegram.svg";
import star from "../../../assets/images/star.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";

export default function HomePrimaryComp() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const { isloggedIn } = useContext(UserContext);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const isMobile = screenWidth < 520;

  const click1 = () => {
    window.open("https://t.me/GlobalForexFundingSupport", "_blank");
  };
  const click2 = () => {
    if (isloggedIn) {
      navigate("/plans");
    } else {
      navigate("/signin?redirect=/plans");
    }
  };
  return (
    <div className="homeprimarycomp__container">
      <div className="homeprimarycomp__left">
        <div className="homeprimarycomp__left__c1">
          <p> Trade with real <br/> funded Capital!</p>
        </div>
        <div className="homeprimarycomp__left__c2">
          <p>
            Trade with real capital, not a simulated account. With the lowest <br/>
            profit targets, manage up to $400k in funding.
          </p>
        </div>
       <div className="buye">
       <div className="buyevalitionbutton">
         Buy Evalution
        </div>
       </div>
        <div className="homeprimarycomp__left__c3">
          <PrimaryButton
            bgColor={"var(--accent-color)"}
            icon={icon}
            title={"Buy Evaluation"}
            marginR={0}
            func={click2}
          />
          {/* <PrimaryButton bgColor={'#58d0fc'} icon={iconTelegram} title={'Join Our Telegram'} func={click1} /> */}
        </div>
        <div className="homeprimarycomp__left__c4">
          <img src={star} loading="lazy" alt="star" /> <p>4.8</p>{" "}
          <p>Rating on Trustpilot {/* • */} </p>
        </div>
      </div>
      <div className="homeprimarycomp__right">
        <div className="homeprimarycomp__right__img">
        
        </div>
        
       

      </div>
      <div className="backgroundvideo">
      <video className="myvideo" autoPlay loop muted playsInline style={{ /* width: '141vw', */ height: 'auto' }}>
  <source src="/video2.mp4" type="video/mp4" />
  Your browser does not support the video tag.
</video>
<div className="innervideo">

<video
            autoPlay
            loop
            muted
            playsInline
          /*   style={{ backgroundColor: "#111", width: "100%", height: "auto" }} */
          >
            <source src="/chart.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
</div>
       </div>


       <div className="homeprimarymobile">

        <div className="buytext">
        <p> Trade with real funded Capital!</p>
        <p>
            Trade with real capital, not a simulated account. With the lowest <br/>
            profit targets, manage up to $400k in funding.
          </p>
        </div>

       <div className="buyev" onClick={click2}>
         Buy Evalution
        </div>

     <section className="homeprimarymobilemain">
     <div className="homeprimarymobilevideo">
         <video className="myvideomobilee" autoPlay loop muted playsInline style={{ /* width: '141vw', */ height: 'auto' }}>
         
         <source src="/video2.mp4" type="video/mp4" />
         </video>
         <video
            autoPlay
            loop
            muted
            playsInline
            className="myvideomobileee"
          /*   style={{ backgroundColor: "#111", width: "100%", height: "auto" }} */
          >
            <source src="/chart.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

         </div>
     </section>
       </div>
    </div>
  );
}
